export default __webpack_public_path__ + "static/media/bg-7.37b1bb15.png";